import { useEffect } from 'react'

import useAppSelector from '../../../store/hooks/useAppSelector'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { clientContextCustomerIdSelector } from '../../clientContext/store/clientContextSelectors'
import { validateCheckout } from '../store/checkoutThunks'
import usePrevious from '../../app/hooks/usePrevious'
import { validatePreOrderCheckout } from '../../preOrder/store/preOrderThunks'
import localStorageUtils from '../../app/utils/localStorageUtils'
import { LocalStorageCartMeta } from '../types'

/**
 * Custom hook that synchronizes checkout data when user authentication state changes.
 * This ensures checkout data is re-fetched when a user signs in or signs out.
 * (Eg: Logged in user might have pricing presets and/or discounts applied to checkout that must be reflected)
 */
export default function useCheckoutAuthSync() {
  const dispatch = useAppDispatch()

  const customerId = useAppSelector(clientContextCustomerIdSelector)
  const prevCustomerId = usePrevious(customerId, true)

  useEffect(() => {
    const checkout = localStorageUtils.getItem<LocalStorageCartMeta>('cartMeta')
    // Check if authentication state has changed and we have an active checkout
    if (prevCustomerId !== customerId && checkout) {
      // User has signed in or signed out - refetch checkout data
      if (checkout.isPreOrderCheckout) {
        dispatch(validatePreOrderCheckout({}))
      } else {
        dispatch(validateCheckout({}))
      }
    }
  }, [customerId, prevCustomerId, dispatch])
}
